<script lang="ts">
    import type { Writable} from "svelte/store";
    import {FeatherShuffle} from "@anyways-open/common-svgs";
    import type { ToolBoxManager } from "../controls/toolbox/ToolBoxManager";
    import type { ToolBoxViews } from "../../scenario/test/ToolBoxViews";

    export let manager: ToolBoxManager<ToolBoxViews>;
    let openToolBox = manager.getOpenToolBoxStore();

    // click event, toggle layer on/off.
    const onClick = () => {
        if ($openToolBox === "compare") {
            $openToolBox = "none";
        } else {
            $openToolBox = "compare";
        }
    };

    const todo = () => {};
</script>

<div on:click={onClick} on:keydown={todo} class="btn btn-toolbox {$openToolBox == 'compare' ? 'active' : ''}">
    <FeatherShuffle class="toolbox-icon" />
</div>


<style>
    .btn-toolbox {
        color: #fff;
    }
</style>